/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import gen2Config from "./gen2-config.json";

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://woox2qdlmh.execute-api.us-east-1.amazonaws.com/rescue",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ecmszxlbzng47nj4d3bzvncpya.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "us-east-1:79d1957a-e138-4d51-8f6b-5ac490e1be1e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_ZvDl2lOUD",
    "aws_user_pools_web_client_id": "59sij2h4k8vsdern2agomfco0",
    "oauth": {
        "domain": "pitchtrackerapp3f30a300-3f30a300-rescue.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://legendsfield.net,https://legendsfield.net/,https://legendsfield.net/login,https://www.legendsfield.net,https://www.legendsfield.net/,https://www.legendsfield.net/login,https://bigtrain.legendsfield.net,https://bigtrain.legendsfield.net/,https://bigtrain.legendsfield.net/login,https://rescue.dehsxvcax2qmw.amplifyapp.com,https://rescue.dehsxvcax2qmw.amplifyapp.com/,https://rescue.dehsxvcax2qmw.amplifyapp.com/login",
        "redirectSignOut": "https://legendsfield.net/logout,https://legendsfield.net/logout/,https://www.legendsfield.net/logout,https://www.legendsfield.net/logout/,https://bigtrain.legendsfield.net/logout,https://bigtrain.legendsfield.net/logout/,https://rescue.dehsxvcax2qmw.amplifyapp.com/logout,https://rescue.dehsxvcax2qmw.amplifyapp.com/logout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};

const gen2Auth = gen2Config.auth || {};
const gen2Data = gen2Config.data || {};
const gen2Oauth = gen2Auth.oauth || {};
const isGen2Host =
    typeof window !== "undefined" &&
    (window.location.hostname === "gen2.legendsfield.net" || window.location.hostname.startsWith("gen2."));
const useGen2 = process.env.REACT_APP_BACKEND === "gen2" || isGen2Host;

const gen2LegacyConfig = {
    aws_project_region: gen2Auth.aws_region || gen2Data.aws_region || "us-east-1",
    aws_appsync_graphqlEndpoint: gen2Data.url || "",
    aws_appsync_region: gen2Data.aws_region || gen2Auth.aws_region || "us-east-1",
    aws_appsync_authenticationType: gen2Data.default_authorization_type || "AMAZON_COGNITO_USER_POOLS",
    aws_cognito_region: gen2Auth.aws_region || "us-east-1",
    aws_user_pools_id: gen2Auth.user_pool_id || "",
    aws_user_pools_web_client_id: gen2Auth.user_pool_client_id || "",
    aws_cognito_identity_pool_id: gen2Auth.identity_pool_id || "",
    oauth: {
        domain: gen2Oauth.domain || gen2Auth.oauthCognitoDomain || "",
        scope: gen2Oauth.scopes || ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
        redirectSignIn: Array.isArray(gen2Oauth.redirect_sign_in_uri)
            ? gen2Oauth.redirect_sign_in_uri.join(",")
            : gen2Auth.oauthRedirectSignIn || "",
        redirectSignOut: Array.isArray(gen2Oauth.redirect_sign_out_uri)
            ? gen2Oauth.redirect_sign_out_uri.join(",")
            : gen2Auth.oauthRedirectSignOut || "",
        responseType: gen2Oauth.response_type || gen2Auth.oauthResponseType || "code"
    },
    aws_cloud_logic_custom: []
};

export default useGen2 ? gen2LegacyConfig : awsmobile;
